import { PeriscopeList } from '@periscopes/general';
import { PeriscopeTagList } from '@periscopes/general/tags';
import React, { useCallback } from 'react';
export const PardotFieldTagsTab = ({ index, tagIds }) => {
    const renderTags = useCallback((data) => React.createElement(PeriscopeTagList, { parentIndex: index, tagIds: data }), [index]);
    return React.createElement(PeriscopeList, { list: renderTags, loading: false, results: tagIds });
};
